import { useEffect, useRef } from "react";
import { CloseRounded, SkipNextRounded } from "@mui/icons-material";

import "./autoplay.scss";

export default function AutoplayCountdown({ videoRef, countdownSeconds, onSkip, onCancel }) {
    const progressRef = useRef(null);
    const textRef = useRef(null);

    // Per-frame DOM updates -- bypasses React's render cycle so the rest of
    // the player (and its children) is not re-rendered every animation frame.
    useEffect(() => {
        let rafId;

        const apply = () => {
            const video = videoRef?.current;
            if (video && video.duration && !isNaN(video.duration)) {
                const remaining = Math.max(0, video.duration - video.currentTime);
                const elapsed = countdownSeconds - remaining;
                const progress = Math.max(0, Math.min(1, elapsed / countdownSeconds));

                if (progressRef.current) {
                    progressRef.current.style.width = `${progress * 100}%`;
                }
                if (textRef.current) {
                    textRef.current.textContent = `Próximo vídeo em ${Math.max(0, Math.ceil(remaining))}s`;
                }
            }
        };

        apply(); // initial sync to avoid a 1-frame flash of empty/zero state

        const tick = () => {
            apply();
            rafId = requestAnimationFrame(tick);
        };
        rafId = requestAnimationFrame(tick);

        return () => cancelAnimationFrame(rafId);
    }, [videoRef, countdownSeconds]);

    function handleCancelClick(e) {
        e.stopPropagation();
        onCancel?.();
    }

    return (
        <button
            type="button"
            className="autoplay-countdown"
            onClick={onSkip}
            aria-label="Pular para o próximo vídeo"
        >
            <span
                ref={progressRef}
                className="autoplay-countdown__progress"
            />

            <span className="autoplay-countdown__content">
                <SkipNextRounded className="autoplay-countdown__icon" />
                <span ref={textRef} className="autoplay-countdown__text" />
            </span>

            <span
                className="autoplay-countdown__close"
                onClick={handleCancelClick}
                role="button"
                aria-label="Cancelar reprodução automática"
            >
                <CloseRounded fontSize="small" />
            </span>
        </button>
    );
}
